module.exports = __webpack_public_path__ + "img/accesoires-huitres-en-ligne-boutrais-small.d0cfc16e.png";